import { RouteConfig } from "vue-router";
import Home from "../views/HomeView.vue";
import { isProd } from "@/services/libs/Utils";

const routes: Array<RouteConfig> = [
  // kommunen routes
  {
    path: "/kommunen",
    name: "KommunenMain",
    props: true,
    meta: {
      requiresAuth: true,
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () =>
      import(
        /* webpackChunkName: "KommunenMain" */ "../views/kommunen/MainView.vue"
      ),
    alias: "/",
  },
  {
    path: "/kommunen/detail/:id",
    name: "KommunenDetail",
    props: true,
    meta: {
      requiresAuth: true,
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () =>
      import(
        /* webpackChunkName: "KommunenDetail" */ "../views/kommunen/DetailView.vue"
      ),
  },
  // maßnahmen routes
  {
    path: "/massnahmen",
    name: "MassnahmenMain",
    props: true,
    meta: {
      requiresAuth: true,
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () =>
      import(
        /* webpackChunkName: "MassnahmenMain" */ "../views/massnahmen/MainView.vue"
      ),
  },
  {
    path: "/massnahmen/detail/:id",
    name: "MassnahmenDetail",
    props: true,
    meta: {
      requiresAuth: true,
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () =>
      import(
        /* webpackChunkName: "MaßnahmenDetail" */ "../views/massnahmen/DetailView.vue"
      ),
  },
  // ansprechpartner routes
  {
    path: "/stammdaten",
    name: "AnsprechpartnerMain",
    props: true,
    meta: {
      requiresWritePermission: true,
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import("../views/ansprechpartner/MainView.vue"),
  },
  {
    path: "/stammdaten/detail/:id",
    name: "AnsprechpartnerDetail",
    props: true,
    meta: {
      requiresWritePermission: true,
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import("../views/ansprechpartner/DetailView.vue"),
  },
  // and finally the default route, when none of the above matches:
  {
    path: "*",
    name: "404",
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/PageNotFound.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      requiresAuth: false,
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import("../views/LoginView.vue"),
  },
];

if (!isProd()) {
  routes.push({
    path: "/home",
    name: "Home",
    props: true,
    meta: {
      requiresAuth: false,
    },
    component: Home,
  });
}

export default routes;
